import React, { useState } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import AnyLink from '../common/anyLink';
import { ellipsize } from '../../utils/textUtil';
import imgParams from '../../utils/imageUtil';
import { imageUrls } from '../../utils/constants';
import { initProfileButtons } from '../../utils/userUtil';
import { useProfileButtons } from '../../hooks/userDataHooks';
import CardButtons from '../user/cardButtons';
import ChampionIcon from '../../img/championIcon.svg';

const RenderUserCardItem = ({ card, index }) => {
  const classes = useStyles();
  const [showBtn, setShowBtn] = useState(initProfileButtons);
  const {
    sayHiBtn,
    pendingBtn,
    followingBtn,
    followBtn,
    confirmTextBtn,
    addFriendBtn,
  } = useProfileButtons({
    isUserProfile: false,
    isFeed: false,
    isCarousel: true,
    userInfoObject: card,
    userId: card && card.userId && card.userId,
    setShowBtn,
    showBtn,
  });

  const newTag =
    card &&
    (card.customProfileString === 'new' ||
      card.profileBadgeUrl ===
        'https://img.sheroes.in/img/uploads/sheroespage/logoes/1586318878feedbadgenewuser.png');

  return (
    <div className={classes.carouselItem}>
      <AnyLink to={card.deepLinkUrl} key={index}>
        <Box
          position="relative"
          className={classes.defaultImg}
          height="100px"
          width="100px"
        >
          <img
            src={
              card.imageUrl === null
                ? imageUrls.DEFAULT_USER_IMG
                : imgParams(card.imageUrl, 480, 'auto', 'auto')
            }
            width="100%"
            alt="User"
            className={
              card.imageUrl === null ? classes.defaultImgSet : classes.videoImg
            }
            height="100%"
          />
          {card?.profileBadgeUrl !== null && (
            <img
              src={card?.profileBadgeUrl}
              alt="Badge"
              className={classes.badgeIcon}
              width={newTag ? '34px' : '16px'}
            />
          )}
          {card && card.userTypeId && card.userTypeId === 7 && (
            <img
              src={ChampionIcon}
              alt="Badge"
              className={classes.badgeIcon}
              width={'18px'}
            />
          )}
        </Box>

        <Box alignItems="center">
          <Typography variant="body2" className={classes.videoDes}>
            {ellipsize(card.name, 15)}
          </Typography>
        </Box>
      </AnyLink>
      <Box mt={3} minHeight={'33px'}>
        {card && !card.isRequestSent && (
          <CardButtons
            userInfoObject={card}
            userId={card && card.userId && card.userId}
            isCarousel={true}
            showBtn={showBtn}
            setShowBtn={setShowBtn}
            sayHiBtn={sayHiBtn}
            pendingBtn={pendingBtn}
            followingBtn={followingBtn}
            followBtn={followBtn}
            confirmTextBtn={confirmTextBtn}
            addFriendBtn={addFriendBtn}
          />
        )}
      </Box>
    </div>
  );
};
export default RenderUserCardItem;
const useStyles = makeStyles((theme) => ({
  defaultImg: {
    margin: '0px auto',
    borderRadius: '50%',
  },
  defaultImgSet: {
    borderRadius: '50%',
  },
  carouselItem: {
    margin: theme.spacing(2, 2, 0, 0),
    padding: theme.spacing(5),
    background: '#fff',
    textAlign: 'center',
  },
  videoImg: {
    borderRadius: theme.spacing(2.5),
  },
  videoDes: {
    color: '#3c3c3c',
    margin: theme.spacing(2, 0),
    textTransform: 'capitalize',
  },
  badgeIcon: {
    position: 'absolute',
    bottom: '-7px',
    margin: '0px auto',
    left: '0',
    right: '0',
  },
}));
